import React from 'react';
import GlobalKanbanFilters from '../../GlobalKanbanFilters';
import { SubHeaderProjectFilterDropdown, SubHeaderVisibilityDropdown } from '../dropdowns';
import { FullProject } from '../../../types';

interface SubHeaderGlobalKanbanControlsProps {
  kanbanMode: 'status' | 'date' | 'custom';
  setKanbanMode: (mode: 'status' | 'date' | 'custom') => void;
  globalFilterAssignee: string;
  setGlobalFilterAssignee: (val: string) => void;
  globalFilterStatus: string;
  setGlobalFilterStatus: (val: string) => void;
  globalFilterType: string;
  setGlobalFilterType: (val: string) => void;
  allAssignees: string[];
  availableTypes: string[];
  availableStatuses: string[];
  workspaceProjects?: FullProject[];
  hiddenProjectIds?: string[];
  setHiddenProjectIds?: (ids: string[]) => void;
  showCompleted?: boolean;
  setShowCompleted?: (val: boolean) => void;
  showArchived?: boolean;
  setShowArchived?: (val: boolean) => void;
  showTaskDetails?: boolean;
  setShowTaskDetails?: (val: boolean) => void;
}

export const SubHeaderGlobalKanbanControls: React.FC<SubHeaderGlobalKanbanControlsProps> = ({
  kanbanMode,
  setKanbanMode,
  globalFilterAssignee,
  setGlobalFilterAssignee,
  globalFilterStatus,
  setGlobalFilterStatus,
  globalFilterType,
  setGlobalFilterType,
  allAssignees,
  availableTypes,
  availableStatuses,
  workspaceProjects,
  hiddenProjectIds,
  setHiddenProjectIds,
  showCompleted,
  setShowCompleted,
  showArchived,
  setShowArchived,
  showTaskDetails,
  setShowTaskDetails
}) => {
  return (
    <div className="flex items-center gap-4">
      <GlobalKanbanFilters 
        filterAssignee={globalFilterAssignee}
        setFilterAssignee={setGlobalFilterAssignee}
        filterStatus={globalFilterStatus}
        setFilterStatus={setGlobalFilterStatus}
        filterType={globalFilterType}
        setFilterType={setGlobalFilterType}
        allAssignees={allAssignees}
        availableTypes={availableTypes}
        availableStatuses={availableStatuses}
      />

      <SubHeaderProjectFilterDropdown
        workspaceProjects={workspaceProjects}
        hiddenProjectIds={hiddenProjectIds}
        setHiddenProjectIds={setHiddenProjectIds}
      />

      <SubHeaderVisibilityDropdown
        showCompleted={showCompleted}
        setShowCompleted={setShowCompleted}
        showArchived={showArchived}
        setShowArchived={setShowArchived}
        showTaskDetails={showTaskDetails}
        setShowTaskDetails={setShowTaskDetails}
      />
    </div>
  );
};
